import classNames from 'classnames';
import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { ajaxErrorHandler } from '../../../libs/utils';
import { getParkings } from '../../../services/api/parkings';
import { getParkingRequests } from '../../../services/api/registrationParkings';
import BasicCheckbox from '../../forms/fields/BasicCheckbox';
import BasicInput from '../../forms/fields/BasicInput';
import BasicSelect from '../../forms/fields/BasicSelect';
import CustomTypeahead from '../../forms/fields/CustomTypeahead';
import { FormikPropTypes } from '../../forms/helpers/formikPropTypes';

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      parking: undefined,
      parkings: [],
      parkingsLoading: false,
      validated: false,
      amountAvailable: undefined,
    };

    this._handleParkingSearch = this._handleParkingSearch.bind(this);
    this._handleParkingSelect = this._handleParkingSelect.bind(this);
  }

  static propTypes = {
    event: PropTypes.object,
    ...FormikPropTypes,
  };

  _handleParkingSearch(value) {
    this.setState({ parkingsLoading: true });

    getParkings(this.props.event.id, {
      'filter[name]': value,
    }).then((response) => {
      this.setState({
        parkings: response.data,
        parkingsLoading: false,
      });
    });
  }

  _handleParkingSelect(parkings) {
    this.setState({
      parking: parkings[0],
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // check amount available on parkingsticker change
    if (this.props.values.parkingStickerId !== nextProps.values.parkingStickerId) {
      getParkingRequests(this.props.crewMember.registrationId, {
        'page[number]': 1,
        'page[size]': 1000,
        'filter[crew_member_id]': this.props.crewMember.id,
        'sort': '-updated_at',
        'include':
          'parking,crew-member,crew-member.user,parking-request-parking-stickers,parking-request-parking-stickers.parking-sticker',
      })
        .then((response) => {
          let stickers = [];
          for (let i = 0; i < response.data.length; i++) {
            const newStickers = [...response.data[i].parkingRequestParkingStickers];
            for (let j = 0; j < newStickers.length; j++) {
              newStickers[j].crewMember = response.data[i].crewMember;
              newStickers[j].parking = response.data[i].parking;
            }

            stickers = stickers.concat(newStickers);
          }

          stickers = stickers.filter((sticker) => sticker.parkingStickerId == nextProps.values.parkingStickerId);
          response.meta.to = stickers.length;
          response.meta.total = stickers.length;

          this.setState({
            validated: true,
            amountAvailable: stickers.filter((sticker) => sticker.claimedAt === null).length,
            amountRedeemed: stickers.filter((sticker) => sticker.claimedAt !== null).length,
          });
        })
        .catch(ajaxErrorHandler);
    }
  }

  render() {
    const props = this.props;
    const { parking, parkings, parkingsLoading, validated, amountAvailable, amountRedeemed } = this.state;
    let { range, codeRangeStop, codeRangeStart } = this.props.values;

    if (!codeRangeStop) {
      codeRangeStop = codeRangeStart;
    }

    let overLimit = 0;
    if (codeRangeStart) {
      overLimit = parseInt(codeRangeStop) - parseInt(codeRangeStart) + 1 - amountAvailable;
    }

    return (
      <form className="m-form" onSubmit={props.handleSubmit}>
        <div className="modal-body" style={{ minHeight: 300 }}>
          <CustomTypeahead
            name="parkingId"
            label="Parking"
            multiple={false}
            options={parkings}
            loading={parkingsLoading}
            placeholder="Choose a parking"
            labelKey={(item) => item.name}
            onSearch={this._handleParkingSearch}
            onChange={this._handleParkingSelect}
            {...this.props}
          />

          {parking && (
            <BasicSelect
              label="Sticker"
              name="parkingStickerId"
              placeholder="Select Sticker Type"
              options={parking.parkingStickers.map((sticker) => ({
                value: sticker.id,
                title: sticker.name,
              }))}
              {...this.props}
            />
          )}

          {validated && (
            <>
              <p>
                This person has <strong>{amountAvailable}</strong> available spots for this parking. ({amountRedeemed}{' '}
                already redeemed)
              </p>

              {overLimit > 0 && (
                <div className="alert alert-danger">
                  Handing out {amountAvailable + overLimit} stickers, which is <strong>{overLimit}</strong> more than
                  available for this person!
                </div>
              )}

              <BasicCheckbox label="Range" name="range" {...this.props} />

              <BasicInput
                type="number"
                label={range ? 'Start Code (included)' : 'Code (included)'}
                name="codeRangeStart"
                {...this.props}
              />

              {range && <BasicInput type="number" label="End Code (included)" name="codeRangeStop" {...this.props} />}
            </>
          )}
        </div>

        <div className="modal-footer">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              <button
                className={classNames([
                  'btn m-btn btn-primary',
                  {
                    'btn-danger': overLimit > 0,
                    'btn-primary': overLimit < 1,
                    'm-btn--custom m-loader m-loader--light m-loader--left': props.isSubmitting,
                  },
                ])}
                disabled={props.isSubmitting}
              >
                Hand out sticker
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const ParkingStickersVouchersAdvancedForm = withFormik({
  mapPropsToValues: (props) => {
    let values = {
      parkingId: '',
      parkingStickerId: '',
      codeRangeStart: '',
      codeRangeStop: '',
      range: false,
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.codeRangeStart || values.codeRangeStart === '') {
      errors.codeRangeStart = 'required';
    }

    if (values.codeRangeStop && values.codeRangeStop < values.codeRangeStart) {
      errors.codeRangeStop = 'invalid range';
    }

    return errors;
  },

  handleSubmit: (values, { props, resetForm, setSubmitting }) => {
    props.onSubmit(values, setSubmitting);
  },
})(InnerForm);

export default ParkingStickersVouchersAdvancedForm;
